import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 导入语言包
import en from './locales/en.json';
import zh from './locales/zh.json';

Vue.use(VueI18n);

const messages = {
  en: en,
  zh: zh
};

const DEFAULT_LOCALE = 'en';

function getInitialLocale() {
  const preferredLanguage = localStorage.getItem('preferredLanguage');
  return Object.prototype.hasOwnProperty.call(messages, preferredLanguage)
    ? preferredLanguage
    : DEFAULT_LOCALE;
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js